import Vue from 'vue'
import lsmyLibs from 'lsmy-libs'
import Cookies from "js-cookie"
import axios from 'axios'
import store from '@/store'
import { VueAxios } from './axios'
import { tansParams } from '@/utils/common'
import qs from "qs";
import { API_PROXY_PREFIX } from "@/services/api";
import { message } from "ant-design-vue";

const _this = Vue.prototype

// http method
const METHOD = {
  GET: "get",
  POST: "post",
  PUT: "put",
  DELETE: "delete",
  NOTOKEN: "noToken",
  POST_FORMDATA: "post_formdata",
  POST_STRING: "string"
};

// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  // baseURL: process.env.VUE_APP_API_BASE_URL,
  withCredentials: false,
  baseURL: API_PROXY_PREFIX,
  timeout: 300000 // 请求超时时间
})

// 异常拦截处理器
const errorHandler = (error) => {
  if (error.response) {
    const data = error.response.data
    // 如果是开发环境，就获取localStorage的token；如果是线上环境，就获取单点登录设置的Admin-Token，若依需要
    const token = (process.env.NODE_ENV === "development" || localStorage.getItem('isFromSystemLogin') === 'true') ? localStorage.getItem('token') : Cookies.get('Admin-Token');
    // const token = storage.get(ACCESS_TOKEN)
    if (error.response.status === 403) {
      _this.$message.error(data.message)
    }
    if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
      _this.$message.error('权限验证失败')
      if (token) {
        if (process.env.NODE_ENV !== "development") {
          location.href = process.env.VUE_APP_API_OASSO_URL + "/sso/?redirectUrl=" + location.origin + "/" + location.hash
        } else {
          store.dispatch('Logout').then(() => {
            if (process.env.NODE_ENV !== 'development') {
              location.href = process.env.VUE_APP_API_OASSO_URL + '/sso/?redirectUrl=' + location.origin + '/' + location.hash;
            } else {
              setTimeout(() => {
                window.location.reload()
              })
            }
          })
        }
      }
    }
  }
  return Promise.reject(error)
}

// request interceptor
function requestInterceptors (config) {
  // 融合无界
  if (window.__POWERED_BY_WUJIE__) {
    console.log(Cookies.get('Admin-Token'), 'Cookies.get(Admin-Token)')
    console.log(Cookies.get(process.env.VUE_APP_XSRF_NAME), `Cookies.get(${process.env.VUE_APP_XSRF_NAME})`)
    Cookies.set('Admin-Token', Cookies.get('sit-fplToken'))
  }
  // 如果是开发环境，就获取localStorage的token；如果是线上环境，就获取单点登录设置的Admin-Token，若依需要
  const token = (process.env.NODE_ENV === "development" || localStorage.getItem('isFromSystemLogin') === 'true') ? localStorage.getItem('token') : Cookies.get('Admin-Token');
  // 如果 token 存在
  // 让每个请求携带自定义 token 请根据实际情况自行修改
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token + (config.aa ? '111' : '')
  }
  // get请求映射params参数
  if (config.method === 'get' && config.params && config.lsmyCommon !== 'lsmyCommon') {
    let url = config.url + '?'
    for (const propName of Object.keys(config.params)) {
      const value = config.params[propName]
      var part = encodeURIComponent(propName) + '='
      if (value !== null && typeof (value) !== 'undefined') {
        if (typeof value === 'object') {
          for (const key of Object.keys(value)) {
            const params = propName + '[' + key + ']'
            var subPart = encodeURIComponent(params) + '='
            url += subPart + encodeURIComponent(value[key]) + '&'
          }
        } else {
          url += part + encodeURIComponent(value) + '&'
        }
      }
    }
    url = url.slice(0, -1)
    config.params = {}
    config.url = url
  }
  return config
}
request.interceptors.request.use(requestInterceptors, errorHandler);

// response interceptor
request.interceptors.response.use((res) => {
  // 未设置状态码则默认成功状态
  const code = res.data.code || 200
  // 获取错误信息
  const msg = res.data.msg
  if (code === 401) {
    if (process.env.NODE_ENV !== "development") {
      lsmyLibs.dialogTimingJump({ title: '登录态已过期，请重新登录', linkTitle: '重新登录', url: process.env.VUE_APP_API_OASSO_URL + "/sso/?redirectUrl=" + location.origin + "/" + location.hash })
    } else {
      // store.dispatch('Logout').then(() => {
      //   location.href = '/'
      // })
      _this.$message.error(msg)
    }
  } else if (code === 500) {
    _this.$message.error(msg)
  } else if (code !== 200) {
    _this.$message.error(msg)
  } else {
    return res.data
  }
  // eslint-disable-next-line prefer-promise-reject-errors
  return Promise.reject({ msg: msg, res: res.data })
}, errorHandler)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, request)
  }
}

/**
 * axios请求
 * @param url 请求地址
 * @param method {METHOD} http method
 * @param params 请求参数
 * @returns {Promise<AxiosResponse<T>>}
 */
 async function requestSet (url, method, params, config) {
  const headerConfig = { };
  const myParams = params;
  const myConfig = Object.assign({ headers: headerConfig }, config);
  myConfig.lsmyCommon = 'lsmyCommon';
  switch (method) {
    case METHOD.NOTOKEN: {
      delete myConfig.headers["SessionKey"];
      return request.get(url, { params: myParams, ...myConfig });
    }
    case METHOD.GET:
      return request.get(url, { params: myParams, headers: headerConfig, ...myConfig });
      case METHOD.DELETE:
        return request.delete(url, { params: myParams, headers: headerConfig, ...myConfig });
    case METHOD.POST:
      return request.post(url, myParams, myConfig);
      case METHOD.PUT:
        return request.put(url, myParams, myConfig);
    case METHOD.POST_FORMDATA:
      return request.post(url, qs.stringify(myParams), myConfig);
    default:
      return request.get(url, { params: myParams, headers: headerConfig, ...myConfig });
  }
}

// 创建下载文件 axios 实例
const exportAxios = axios.create({
  withCredentials: false,
  timeout: 300000 // 请求超时时间
})
exportAxios.interceptors.request.use(requestInterceptors, errorHandler);

async function requestExportPost (requestUrl, params, myFileName) {
  const _this = Vue.prototype;
  return exportAxios.post(
    requestUrl,
    params,
    {
      responseType: 'blob'
    }
  ).then(res => {
    const contentType = res?.headers?.['content-type']
    if (contentType && contentType.includes('application/json')) { // 报错
      res.data.text().then(json => {
        json = JSON.parse(json);
        if (json.code !== 200) {
          _this.$message.error(json.msg);
        }
      })
    } else { // 返回文件
      const filename = myFileName || res.headers["content-disposition"] || '导出数据';
      const a = document.createElement("a");
      if ('download' in a) {
        const url = window.URL.createObjectURL(res.data);
        a.href = url;
        a.download = decodeURIComponent(filename.replace("attachment;filename=", ""));
        a.click();
        window.URL.revokeObjectURL(url);
      } else { // ie
        window.navigator.msSaveBlob(res.data, filename);
      }
    }
  }).catch((err) => {
    console.log(err)
    _this.$message.error(err || '导出文件过程中出错');
  });
}

// 通用下载方法
export function download (url, params = {}, filename) {
  return request.post(url, params, {
    transformRequest: [(params) => {
      return tansParams(params)
    }],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    responseType: 'blob'
  }).then((data) => {
    if (data.type && data.type === 'application/json') {
      this.$message.error('下载失败')
      return
    }
    const content = data
    const blob = new Blob([content])
    if ('download' in document.createElement('a')) {
      const elink = document.createElement('a')
      elink.download = filename
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href)
      document.body.removeChild(elink)
    } else {
      navigator.msSaveBlob(blob, filename)
    }
  }).catch((r) => {
    console.error(r)
  })
}

// 通用下载方法（JSON方式）
export function downloadByJson (url, params = {}, filename, config = {}) {
  const options = {
    method: 'post',
    url,
    data: JSON.stringify(params), // 将参数转换为JSON字符串
    headers: {
      'Content-Type': 'application/json;charset=UTF-8' // 更改Content-Type为application/json
    },
    responseType: 'blob',
    ...(config || {})
  };

  return request(options).then((data) => {
    if (data.type && data.type === 'application/json') {
      this.$message.error('下载失败')
      return
    }
    const content = data
    const blob = new Blob([content])
    if ('download' in document.createElement('a')) {
      const elink = document.createElement('a')
      elink.download = filename
      elink.style.display = 'none'
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)
      elink.click()
      URL.revokeObjectURL(elink.href)
      document.body.removeChild(elink)
    } else {
      navigator.msSaveBlob(blob, filename)
    }
  }).catch((r) => {
    console.error(r)
  })
}

// 解析响应有可能是文件，也有可能是json的情况
/**
 * 解析响应数据
 * @param res
 * @param successCB
 * @param fileName
 * @param config 配置项，默认{}，可包含
 * {
 *  setTip: '自定义提示'
 * }
 */
export function parseResFileOrJson(res, successCB, fileName, config) {
  const data = res;
  const reader = new FileReader();
  reader.onload = function () {
    try {
      const resData = JSON.parse(this.result); // 这个this指的是reader
      if (resData?.code === 200) {
        message.success('导入成功');
        successCB && successCB(resData);
      } else {
        message.error(resData.msg);
      }
    } catch (err) {
      console.error(err)
      if(config?.setTip) {
        message.warning(config.setTip);
      } else {
        message.error('导入文件有误，详情请查看错误文件');
      }
      // let fileName = res?.headers['content-disposition']
      // if (fileName && fileName.length >= 2) {
      //   fileName = fileName.split('=')[1]
      // }
      // fileName = decodeURIComponent(fileName) || '测试';
      const url = window.URL.createObjectURL(new Blob([data]))
      const a = document.createElement('a')
      a.href = url
      a.setAttribute('download', fileName)
      a.click();
      window.URL.revokeObjectURL(url);
    }
  }
  reader.readAsText(data);
}

export default request;

export {
  installer as VueAxios,
  request as axios,
  METHOD,
  requestSet,
  requestExportPost
}
